import { ITEM_DRAG_TOGGLE, ITEM_DRAG_DROP } from '../constants/action-types';

export const itemDragToggle = mode => ({
  type: ITEM_DRAG_TOGGLE,
  mode,
});

export const itemDragDropped = () => ({
  type: ITEM_DRAG_DROP,
});
